module.exports = require("core-js-pure/stable/object/keys");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/object/keys.js
// module id = 610
// module chunks = 0